import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-restore-icon',
  imports: [],
  templateUrl: './restore-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './restore-icon.component.scss',
})
export class RestoreIconComponent {}
